import { useContext, useMemo, useState, type ReactNode } from "react";
import { RouteBodyStateContext, type Snapshot } from "#route-body-state-context";
export function RouteBodyStateProvider({ children }: { children: ReactNode }) {
  const [snapshot] = useState<Snapshot>(() => new Map());
  const value = useMemo(() => ({ prefix: "", snapshot }), [snapshot]);
  return <RouteBodyStateContext value={value}>{children}</RouteBodyStateContext>;
}

export function RouteBodyStateScope({ children, name }: { children: ReactNode; name: string }) {
  const parent = useContext(RouteBodyStateContext);
  const value = useMemo(
    () => (parent === null ? null : { ...parent, prefix: `${parent.prefix}/${name}` }),
    [name, parent],
  );
  return <RouteBodyStateContext value={value}>{children}</RouteBodyStateContext>;
}
